
import { useState, useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import CampaignMiniBanner from '../../components/feature/CampaignMiniBanner';
import ChairLineupHero from './components/ChairLineupHero';
import ChairLineupModels from './components/ChairLineupModels';
import ChairLineupFeatures from './components/ChairLineupFeatures';
import ChairLineupComparison from './components/ChairLineupComparison';
import ChairLineupCTA from './components/ChairLineupCTA';

export default function ChairLineupPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative">
      <Navbar scrolled={scrolled} />
      <div className="pt-16 sm:pt-20">
        <CampaignMiniBanner />
      </div>
      <main>
        <ChairLineupHero />
        <ChairLineupModels />
        <ChairLineupFeatures />
        <ChairLineupComparison />
        <ChairLineupCTA />
      </main>
      <Footer />
    </div>
  );
}
